const SLICE_NAME = 'aiSuggestions';

/**
 * `ai_suggestion` event vocabulary, shared across the consume side (accept/dismiss
 * hooks) so discriminator strings live in one place rather than inline literals.
 */

// `data.suggestion_type` discriminators.
export const SUGGESTION_TYPE = {
  OFFER_UPSELL: 'offer_upsell',
} as const;

// `data.reason_code` values the AI stamps on upsell suggestions. Only
// POST_READBACK (the donation) is consumed today; the other two are the
// mid/end-of-order upsells, centralized here for the deferred scope.
export const UPSELL_REASON_CODE = {
  POST_READBACK: 'POST_READBACK_UPSELL',
  END_OF_ORDER: 'END_OF_ORDER_UPSELL',
  AVAILABLE: 'UPSELL_AVAILABLE',
} as const;

export { SLICE_NAME };
